import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import watch from './attrs/watch'
import { Cropper } from 'vue-advanced-cropper'
import Loading from './../../../../../../../Loading/Index'

export default {
    name: 'MasterOfCeremonies',
    computed,
    data,
    methods,
    watch,
    components: {
        Cropper,
        Loading
    }
}
